module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Building-0e232703d5ba59f7fdc216fbf438c69d.svg";